import {
    close,
    destroy,
    getState,
    init,
    open,
    reset,
    changeReadingRate,
    setBrowserVoice,
    setColor,
    setLanguage,
    setPosition,
    setProfile,
    setVoiceEngine,
} from './init';

export const Inclusive = {
    init,
    open,
    close,
    reset,
    setProfile,
    setLanguage,
    setVoiceEngine,
    setBrowserVoice,
    changeReadingRate,
    setPosition,
    setColor,
    getState,
    destroy,
};

export const UGACCESS = Inclusive;

declare global {
    interface Window {
        Inclusive: typeof Inclusive;
        UGACCESS: typeof Inclusive;
    }
}

if (typeof window !== 'undefined') {
    window.Inclusive = Inclusive;
    window.UGACCESS = UGACCESS;
    autoInit();
}

function autoInit(): void {
    const script =
        (document.currentScript as HTMLScriptElement | null) ??
        document.querySelector<HTMLScriptElement>(
            'script[data-application-id][src*="inclusive.js"]',
        );

    if (!script) {
        return;
    }

    const applicationId = script.dataset.applicationId?.trim();

    if (!applicationId) {
        return;
    }

    const start = (): void => {
        void init({
            applicationId,
            apiBaseUrl: script.dataset.apiBaseUrl?.trim() || undefined,
            language: script.dataset.language?.trim() || undefined,
            color:
                script.dataset.color?.trim() ||
                script.dataset.colorCode?.trim() ||
                script.dataset.themeColor?.trim() ||
                script.dataset.accentColor?.trim() ||
                undefined,
            position:
                script.dataset.position === 'bottom-left' ||
                script.dataset.position === 'top-right' ||
                script.dataset.position === 'top-left'
                    ? script.dataset.position
                    : 'bottom-right',
        });
    };

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', start, { once: true });

        return;
    }

    start();
}

export {
    changeReadingRate,
    close,
    destroy,
    getState,
    init,
    open,
    reset,
    setBrowserVoice,
    setColor,
    setLanguage,
    setPosition,
    setProfile,
    setVoiceEngine,
};
export default Inclusive;
